import { useEffect, useState } from 'react';
import { getOptionItems, OptionItem } from 'helpers/getOptionItems';
import Services from 'services/Services';

type LabeledEntity = {
  id: string,
  label: string,
}

type VehicleOptions = {
  typeOps: OptionItem[]
  lengthRangeOps: OptionItem[]
  slideOps: OptionItem[]
  towingOps: OptionItem[]
  electricalOps: OptionItem[]
}

export function useVehicleOps(condition: boolean = true): [VehicleOptions] {
  const [vehicleOps, setVehicleOps] = useState<VehicleOptions>({
    typeOps: [], lengthRangeOps: [], slideOps: [], towingOps: [], electricalOps: []
  });

  useEffect(() => {
    condition && loadData();
  }, [condition]);

  const loadData = async () => {
    const getByLabel = (entities: LabeledEntity[]) => getOptionItems(entities, x => x.label);

    const lookups = await Services.VehicleLookups.getLookups();
    setVehicleOps({
      typeOps: getByLabel(lookups.types),
      lengthRangeOps: getByLabel(lookups.lengthRanges),
      slideOps: getByLabel(lookups.slides),
      towingOps: getByLabel(lookups.towings),
      electricalOps: getByLabel(lookups.electricals),
    })
  };

  return [vehicleOps];
}
